import {TodoistSync} from "./TodoistSync";
import {
    BuilderInterface,
    BuilderOptionInterface,
    Collection, DateParse,
    EntityTimeInterface,
    FilterInterface,
    GroupInterface,
    GroupMethodInterface,
    TimeFormat,
    TimeFormatInterface,
} from "./Main";
import {LabelInterface, LabelTime} from "./Labels";
import {ProjectInterface} from "./Projects";
import { ColorTypeSingleton, ColorTypeInterface} from "./Color";
import {PRIORITIES, PriorityInterface} from "./Priority";
import {CollectionHelper} from "./App";
import {SectionInterface, SectionSingleton} from "./Section";

export interface TaskInterface extends EntityTimeInterface{


    getId():number|string;
    getLabels(): Collection<LabelInterface>;
    getDateAdd(): Date;
    getProject(): ProjectInterface;
    getTitle():string;
    getLink():string;
    getLinkInApp():string;
    hasDate(): boolean;
    hasDueTime(): boolean;
    getDueDate(): Date;
    setPriority(priority: PriorityInterface): void;
    getPriority(): PriorityInterface;
    time(): TimeFormatInterface;

    /**
     * @deprecated
     */
    getTime(): TimeFormatInterface;


    addLabel(label: LabelInterface):void;
    setProject(project: ProjectInterface): void;
    getColor(): ColorTypeInterface;


    setSection(section: SectionInterface): void;
    getSection(): SectionInterface;

    getParentId(): number;
    addChildTask(task: TaskInterface): void;
    getChildTasks(): Collection<TaskInterface>;

    // id: number
    // day_order: number;
    // assigned_by_uid: string
    // is_archived: number
    // labels: number[]
    // sync_id: string
    // date_added: string
    // priority: number
    // has_more_notes: boolean
    // due_date_utc: string
    // content: string
}

abstract class TaskAbstract implements TaskInterface{


    protected readonly labelIds: number[];
    protected readonly projectId: number;
    protected project: ProjectInterface;
    protected labels: Collection<LabelInterface> = new Collection();
    protected childTasks: Collection<TaskInterface> = new Collection();
    protected priority: PriorityInterface;
    protected section: SectionInterface;
    protected parentId: number;

    constructor(private readonly task: TodoistSync.TaskInterface){
        this.labelIds = task.labels;
        this.projectId = this.task.project_id;
        this.parentId = this.task.parent_id

    }


    getDateAdd(): Date {
        return new Date(this.task.date_added);
    }

    getId(): string|number {
        return this.task.id;
    }

    hasDate(): boolean{
        return !!this.task.due;
    }

    hasDueTime(): boolean {
        return this.hasDate() && this.getDueDate().getHours() != 0;
    }

    getDueDate(): Date {
        /**
         * @todo сделтать вычет текущей временной зоны если у даты нет Z
         */
            return new Date(this.task.due.date);
    }


    getLabels(): Collection<LabelInterface> {
        return this.labels;
    }

    setPriority(priority: PriorityInterface) {
        return this.priority = priority;
    }
    getPriority(): PriorityInterface {
        return this.priority;
    }

    getProject(): ProjectInterface {
        return this.project;
    }

    getTitle(): string {
        return this.task.content;
    }

    time(): TimeFormatInterface{
       return  this.getTime()
    }


    getTime(){
        let timeLabelCollection: Collection<LabelTime> = this.getLabels().filter(function (label) {
            return label instanceof LabelTime;
        });

        return  CollectionHelper.sumTime(timeLabelCollection);
    }

    addLabel(label: LabelInterface): void {
            this.labels.addItem(label);
            if(!label.getTasks().isset(this)) {
                label.addTask(this);
            }
    }


    setProject(project: ProjectInterface): void {
            this.project = project;
            project.addTask(this);

    }

    getLink(): string {
        return "https://app.todoist.com/app/task/"+this.getId();
        // return "todoist://task?id="+this.getId();
    }

    getLinkInApp(): string {
        return "todoist://task?id="+this.getId();
    }

    getColor(): ColorTypeInterface {

        let color : ColorTypeInterface;
        if(!this.getProject().getColor().isEmpty()){
            color =  this.getProject().getColor();
        }else {
            let filteredLabels = this.getLabels().filter(value => !(value instanceof LabelTime));
            if (filteredLabels.length) {
                color = filteredLabels.getItems()[0].getColor();
            }
        }
        return  color && !color.isEmpty() ? color: ColorTypeSingleton.getInstance().getDefaultColor();
    }

    getSection(): SectionInterface {
        return this.section || SectionSingleton.getInstance();
    }

    setSection(section: SectionInterface): void {
        this.section = section;
    }

    addChildTask(task: TaskInterface): void {
        this.childTasks.addItem(task);
    }

    getChildTasks(): Collection<TaskInterface> {
        return this.childTasks;
    }

    getParentId(): number {
        return  this.parentId;
    }

}


export class Task extends TaskAbstract{

}

interface TaskBuilderOptionInterface extends BuilderOptionInterface{
    props: {
        labels: Collection<LabelInterface>
        , projects: Collection<ProjectInterface>
        , sections?: Collection<SectionInterface>
    }
}

export class TaskBuilder implements BuilderInterface<TodoistSync.TaskInterface, Task>{


    private readonly date: Date;

    constructor(private options: TaskBuilderOptionInterface) {

        this.date = new Date();
    }


    build(item: TodoistSync.TaskInterface): Task {

        if(item.due && item.due.date.search('Z') == -1){
            let date = new DateParse(item.due.date);
            item.due.date = date.createDate().toISOString();
        }

        let task =  new Task(item);
        let priority = PRIORITIES.find(function (priority) {
           return  priority.getId() == item.priority;
        })

        task.setPriority(priority);

        this.options.props.labels.getItems().forEach((value => {
            if(item.labels.indexOf(value.getName()) != -1) {
                task.addLabel(value);
            }
        }));
        this.options.props.projects.getItems().forEach((value => {
            if(item.project_id == value.getID()) {
                task.setProject(value);
            }
        }));

        this.options.props.sections.getItems().forEach((section => {
            if(item.section_id == section.getId()) {
                task.setSection(section);
            }
        }));
        return  task;
    }

}


interface DateAssocArrayInterface {
    [key: string]: Date;
}

export class TaskGroup {

    static byDate(): GroupMethodInterface<TaskInterface, Date>{
        let date: DateAssocArrayInterface = {};

        return function(item: TaskInterface){
            let key = item.getDueDate().toLocaleString('default', {day:"numeric", month: "numeric", year: "numeric"});
            if(key in date){
               return  date[key];
            }

            let groupDate = new Date();
            groupDate.setDate(item.getDueDate().getDate());
            groupDate.setMonth(item.getDueDate().getMonth());
            groupDate.setFullYear(item.getDueDate().getFullYear());

            date[key] = groupDate;
            return  date[key];

           // return item.getDueDate().getDate();
        }



    }

}

export class TaskFilter {

    static dayCount(day : number): FilterInterface<TaskInterface> {
        let dateNow = new Date();
        dateNow.setDate((dateNow.getDate()+day));
        return function (item: TaskInterface, index, array) {
            if(!item.hasDate()){
                return  false;
            }
            let date = item.getDueDate();

            return date != undefined &&  date.getDate() <= dateNow.getDate()
        }

    }
    static maxDayShow(day : number): FilterInterface<TaskInterface> {
        let dateStart = new Date();
        dateStart.setHours(0,0,0,0);
        let dateFuture = new Date();
        dateFuture.setHours(0,0,0,0);
        dateFuture.setDate((dateFuture.getDate()+day));

        return function (item: TaskInterface, index, array) {
            if(!item.hasDate()){
                return  false;
            }
            let date = item.getDueDate();

            return date != undefined &&  dateStart <= date
                && date < dateFuture
        }

    }
}